import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

import { nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoGrowTextarea',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const textarea = ref<HTMLTextAreaElement>();
let observer: ResizeObserver | undefined;
let width = -1;
function resize() {
  const element = textarea.value;
  if (!element || !element.clientWidth) return;
  element.style.height = "auto";
  const borders = element.offsetHeight - element.clientHeight;
  element.style.height = `${element.scrollHeight + borders}px`;
}
function input(event: Event) {
  emit("update:modelValue", (event.target as HTMLTextAreaElement).value);
  resize();
}
watch(() => props.modelValue, () => nextTick(resize));
onMounted(() => {
  resize();
  observer = new ResizeObserver(entries => {
    const nextWidth = entries[0]?.contentRect.width;
    if (nextWidth !== undefined && nextWidth !== width) {
      width = nextWidth;
      resize();
    }
  });
  if (textarea.value) observer.observe(textarea.value);
});
onBeforeUnmount(() => observer?.disconnect());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    ref_key: "textarea",
    ref: textarea,
    value: __props.modelValue,
    rows: "1",
    onInput: input
  }, null, 40, _hoisted_1))
}
}

})